export default "__VITE_ASSET__Dz$vyclT__"